import { useToggle } from 'ahooks';
import {
    Divider,
    Flex,
    Button,
    useStyles,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import { Filter } from '@archipro-design/icons';

import FilterDrawer, { applyCount } from './FilterDrawer';
import type { FilterStates } from '~/modules/magazine/type/filter-states';
import { useFilterStates } from './use-magazine-filter-states';
import AppliedFilters from '~/modules/search/components/search-filter-section/AppliedFilters';
import { FilterSectionMobile } from './FilterSection.mobile';

import * as S from './FilterSection.style';
import type { digitalPublicationFilters } from '../../api/digital-publication-filters.server';

export interface CategoryFilterSectionProps {
    initialStates: FilterStates;
    filters: Awaited<ReturnType<typeof digitalPublicationFilters>>;
}

export const FilterSection = (props: CategoryFilterSectionProps) => {
    const { initialStates, filters } = props;
    const { css } = useStyles();
    const [
        filterDrawerOpen,
        { toggle: toggleFilterDrawer, set: setFilterDrawerState },
    ] = useToggle(false);

    const { filterStates, appliedFilters, clearAllFilters } = useFilterStates({
        initialStates,
        active: true,
    });

    const { desktop } = useAppDisplayModeContext();
    if (!desktop) return <FilterSectionMobile {...props} />;

    return (
        <div className={css(S.FilterSectionWrapper)}>
            <Divider size={2} />
            <Flex column gap="space-24">
                <Flex vAlign="center" gap="space-36">
                    <Button
                        transparent
                        size={30}
                        variables={{ buttonPadding: 0, iconPadding: 0 }}
                        iconBefore={<Filter />}
                        onClick={toggleFilterDrawer}
                    >
                        {applyCount('Show Filters', appliedFilters.length)}
                    </Button>
                </Flex>
                {appliedFilters && appliedFilters.length > 0 && (
                    <AppliedFilters
                        filterItems={appliedFilters}
                        resetFilters={() => clearAllFilters()}
                    />
                )}
            </Flex>

            <FilterDrawer
                open={filterDrawerOpen}
                onOpenChange={(_, data) => setFilterDrawerState(!!data)}
                initialStates={filterStates}
                filters={filters}
                onApplyFilters={() => {
                    setFilterDrawerState(false);
                }}
            />
        </div>
    );
};
